// Safari 10 nomodule fix:
if ( window.MAIN_EXECUTED ) {
    throw new Error( '' )
}
window.MAIN_EXECUTED = true

// Polyfills:
import '@babel/polyfill'
objectFitImages()

// requestIdleCallback:
window.requestIdleCallback = window.requestIdleCallback || function( handler ) {
	let startTime = Date.now()

	return setTimeout( function() {
		handler( {
			didTimeout: false,
			timeRemaining: function() {
				return Math.max( 0, 50.0 - ( Date.now() - startTime ) )
			}
		} )
	}, 1 )
}

window.cancelIdleCallback = window.cancelIdleCallback || function( id ) {
	clearTimeout( id )
}

// scrollTo:
window.scrollTo = window.scrollTo || function( x, y ) {
	window.scrollLeft = x
	window.scrollTop = y
}

// External Dependencies:
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'
import objectFitImages from 'object-fit-images'
import i18n from 'i18n-calypso'

// Internal Dependencies:
import SiteContainer from 'church-theme-library/containers/SiteContainer'
import PageTracker from 'church-theme-library/containers/PageTracker'
import { doRequest } from 'church-theme-library/utilities/request'
import { getUserPreferredLocale } from 'church-theme-library/utilities/i18n'

const locale = getUserPreferredLocale( siteData.locales_slugs, siteData.locale_base )
let skipLocaleLoad = false

if ( 'en' == locale ) {
	skipLocaleLoad = true
}

// Redux:
import { Provider } from 'react-redux'
import configureStore from 'church-theme-library/redux/store/configure-store'
const store = configureStore()

function renderSite( localeData ) {
	ReactDOM.render(
		<Provider store={ store }>
			<BrowserRouter basename={ siteData.site_base_path }>
				<Route path="/" component={ PageTracker( SiteContainer ) } />
			</BrowserRouter>
		</Provider>,

		document.getElementById( 'app' )
	)
}

// Attempt to load the locale file:
if ( skipLocaleLoad ) {
	// Load:
	renderSite()
} else {
	// Get the locale file, then load:
	doRequest( `${siteData.languages_url}${locale}.json?v=${siteData.version}` )
		.then( json => {
			// Load the locale.
			i18n.setLocale( json )

			renderSite()
		} )
		.catch( error => {
			// If there is an error loading the locale, use the default.
			renderSite()
		} )
}
